import angular from 'angular';
import uiRouter from 'angular-ui-router';
import cardAvatarComponent from './cardAvatar.component';

let cardAvatarModule = angular.module('cardAvatar', [
  uiRouter
])

.component('cardAvatar', cardAvatarComponent)

.name;

export default cardAvatarModule;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/userCardList/userCardRow/homeCard/cardAvatar/cardAvatar.js